/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const TypographyDefaultMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    'subheading-large': 'span',
    'subheading-medium': 'span',
    'subheading-small': 'span',
    'body-large': 'span',
    'body-medium': 'span',
    'body-small': 'span',
    code: 'code',
    label: 'span',
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _CodeElement = {
    // @ts-expect-error href is not a valid prop for a code element
    href: 'https://www.neo4j.com',
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// @ts-expect-no-error href is a valid prop for an anchor element
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _AnchorElement = {
    href: 'https://www.neo4j.com',
};
//# sourceMappingURL=types.js.map